import { CoreModal, CoreModalDescription } from "@verity/components/core";
import i18n from "../../../../../i18n";

type UnsavedChangesModalProps = {
	onClose: () => void;
	onSaveGrade: () => void;
	onSaveLater: () => void;
	onCancel: () => void;
	attemptNumber: number;
};

export default function UnsavedChangesModal({
	onClose,
	onSaveGrade,
	onSaveLater,
	onCancel,
	attemptNumber,
}: UnsavedChangesModalProps) {
	return (
		<CoreModal
			title={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.unsavedChanges.title", {
				number: attemptNumber,
			})}
			open
			onClose={onClose}
			maxWidth={"600px"}
			buttons={[
				{
					text: i18n.t("result.components.resultsPage.proctoringResultsViewTSX.unsavedChanges.cancel"),
					color: "cancel",
					onClick: onCancel,
					sx: {
						marginRight: "auto",
					},
				},
				{
					text: i18n.t("result.components.resultsPage.proctoringResultsViewTSX.unsavedChanges.saveDraft"),
					color: "secondary",
					onClick: () => onSaveLater(),
				},
				{
					text: i18n.t("result.components.resultsPage.proctoringResultsViewTSX.unsavedChanges.finalizeGrade"),
					color: "primary",
					onClick: () => onSaveGrade(),
				},
			]}
		>
			<CoreModalDescription>
				{i18n.t("result.components.resultsPage.proctoringResultsViewTSX.unsavedChanges.description")}
			</CoreModalDescription>
		</CoreModal>
	);
}
